module.exports = __webpack_public_path__ + "media/images/service/c_1-87f5fc02a00a8ebf83709c8310327b10.png";